"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var detectors_1 = require("./detectors");
var detectors = {
    ie10: detectors_1.detectMSIE,
    ie11: detectors_1.detectTrident,
    edge: detectors_1.detectEdge
};
function checkIE(userAgent, options) {
    var notIE = { isIE: false, name: '', version: '' };
    if (!userAgent)
        throw new Error('No user agent supplied.');
    else {
        for (var check in detectors) {
            if (options && !options[check])
                continue;
            var result = detectors[check](userAgent);
            if (result.isIE)
                return result;
        }
        return notIE;
    }
}
exports.default = checkIE;
//# sourceMappingURL=index.js.map